export default __webpack_public_path__ + "static/media/cc2021 (5).0da71b9f.jpg";